import * as errors from "../errors.js";
import { state } from "../state.js";
import { BASIC_SETTINGS } from "../BASIC.js";

/*
    The BASIC command GOTO makes the BASIC interpreter branch to the indicated line and the execution of the BASIC program is continued at that line. 
    In Commodore BASIC, legal line numbers are from 0 to 63999. Exceeding the upper limit leads to an ?SYNTAX ERROR. If the targeted line number doesn't exist, 
    the BASIC error ?UNDEF'D STATEMENT ERROR occurs. A special case is the usage without a parameter which implicitly refers to line number 0.
    The line number is expected to be a numeric constant consisting of digits only (possibly intermixed with spaces) until the first non-digit character. 
    All the following characters until the end of the line are ignored and can be regarded as a comment. 
*/
export const goto = async (args) => {
    let lineNumber = 0; // Initialize lineNumber to 0.

    // Remove all spaces from args.
    args = args.replace(/\s/g, "");
    
    // Check if args is empty.
    if (args !== undefined && args.length > 0) {
        // Parse the args to a number. All digits up to the first non-digit character make up the line number.
        // For example, "123abc" becomes 123.
        const match = args.match(/^\d+/); // Match one or more digits at the start of the string.
        if (!match) {
            // If no digits are found, throw a syntax error.
            throw new errors.SyntaxError();
        }
        lineNumber = parseInt(match[0], 10); // Convert the matched digits to an integer.    
    }

    if (isNaN(lineNumber)) {
        // If the line number is not a number, throw a syntax error.
        throw new errors.SyntaxError();
    }
    
    // Check if the line number is within the valid range.
    if (lineNumber < 0 || lineNumber > state.maxLineNumber) {
        throw new errors.SyntaxError();
    }

    BASIC_SETTINGS.goto = lineNumber;
};